<template>
    <div id="loginbox" class="animated fadeIn">
        <div class="bg">
            <div class="close" @click="close">✘</div>
            <div class="content">
                <div class="img">
                    <img :src="logo" />
                </div>
                <div class="box">
                    <div class="input">
                        <div>帳號</div>
                        <input
                            type="text"
                            placeholder="請輸入您的帳號"
                            v-model="login.Email"
                            @keyup.13="LoginApi"
                        />
                    </div>
                    <div class="input">
                        <div>密碼</div>
                        <input
                            type="password"
                            placeholder="請輸入您的密碼"
                            v-model="login.Password"
                            @keyup.13="LoginApi"
                        />
                    </div>
                    <div class="password">
                        <a href="/Home/ForgotPassword">忘記密碼?</a>
                    </div>
                </div>
            </div>
            <div class="btn_box">
                <div class="Orange_btn islogin" @click="LoginApi">
                    <a href="javacript:;">登入</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from "@/service/member";
export default {
    name: "loginbox",
    components: {},
    props: {},
    data() {
        return {
            logo: require("@/assets/logo.png"),
            login: {
                Email: "",
                Password: ""
            }
        };
    },
    methods: {
        close() {
            const vm = this;
            let Loginbox = document.getElementById("loginbox");
            // console.log(Loginbox);
            Loginbox.style.display = "none";
            $(document).unbind("scroll");
            // vm.$emit("sendLoginStatus", false);
        },
        LoginApi() {
            const vm = this;
            let params = vm.login;
            if (params.Email == "") {
                vm.$swal({
                    type: "warning",
                    text: "帳號為空",
                    confirmButtonText: "確定"
                });
                return false;
            } else if (params.Password == "") {
                vm.$swal({
                    type: "warning",
                    text: "密碼為空",
                    confirmButtonText: "確定"
                });
                return false;
            }
            API.getLogin(params).then(result => {
                // console.log(result);
                if (!result) {
                    vm.$swal({
                        type: "warning",
                        text: "帳號或密碼錯誤",
                        confirmButtonText: "確定"
                    });
                } else {
                    vm.$swal({
                        type: "success",
                        text: "登入成功",
                        confirmButtonText: "確定"
                    }).then(() => {
                        let _router = location.pathname.split("/")[1];

                        if (_router != "Event") {
                            location.href = "/Member/Status";
                        } else {
                            location.reload();
                        }

                        setTimeout(function() {
                            location.reload();
                        }, 2000);
                    });
                }
            });
        }
    },
    computed: {},
    created() {},
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#loginbox {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100vh;
    z-index: 105;
    background-color: rgba(0, 0, 0, 0.7);
    display: none;
    /* display: flex; */
    align-items: center;
    justify-content: center;
    color: #666;
}
#loginbox .bg {
    background-color: #fff;
    width: 500px;
    padding: 20px 30px;
    min-height: 250px;
    text-align: center;
    position: relative;
    border-radius: 5px;
}
#loginbox .close {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    transition: 0.35s;
}
#loginbox .close:hover {
    color: #ee8b59;
}
#loginbox .img {
    width: 200px;
    margin: auto;
    font-size: 0;
}
#loginbox .img img {
    width: 100%;
}
#loginbox .box {
    padding: 30px 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    /* border-top: 1px solid #ccc; */
    margin-top: 20px;
}
#loginbox .box .password {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
#loginbox .box .password a {
    text-decoration: none;
    color: #ccc;
    font-size: 0.9rem;
    padding-top: 8px;
    transition: 0.35s;
}
#loginbox .box .password a:hover {
    color: #ee8b59;
}
#loginbox .box .input {
    width: 100%;
}
#loginbox .box .input:nth-child(1) {
    margin-bottom: 15px;
}
#loginbox .box .input > div {
    text-align: left;
    font-size: 1.2rem;
    padding: 5px 0;
}
#loginbox .box .input > input {
    width: 100%;
    border: 1px solid #ccc;
    padding: 5px 10px;
    height: 36px;
}
#loginbox .bg .btn_box {
    width: 100%;
    margin: auto;
    padding: 15px 0;
}
@media screen and (max-width: 767px) {
    #loginbox .bg {
        width: 95%;
    }
    #loginbox .box .input {
        width: 100%;
        /* margin-bottom: 15px; */
    }
}
</style>




// WEBPACK FOOTER //
// src/components/loginbox/index.vue